(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wetome-konto"] && !Shopify.designMode) return;
  try {
    (() => {
    // Menüpunkte im Konto-Fenster: ruhige Zeilen mit Symbol links, Pfeil rechts und weichem Hintergrund beim Darüberfahren.
    // Das Symbol richtet sich nach dem Linkziel, unbekannte Ziele bleiben ohne Symbol.
    const symbol = (pfad) =>
      `url("data:image/svg+xml,${encodeURIComponent(
        `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'>${pfad}</svg>`
      )}")`;
    const symbole = {
      '/account/orders': '<path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/>',
      '/account/profile': '<circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 0 0-16 0"/>',
      'wetome-navigator': '<circle cx="12" cy="12" r="10"/><path d="m16.24 7.76-2.12 6.36-6.36 2.12 2.12-6.36z"/>',
      '/account/pages/': '<path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>',
    };
    const symbolregeln = Object.entries(symbole)
      .map(([ziel, pfad]) => `.account__item[href*="${ziel}"]::before { display: block; --wetome-symbol: ${symbol(pfad)}; }`)
      .join(' ');
    const regeln = `
      .account__heading { font-size: 1.2rem; letter-spacing: -0.01em; }
      .account__email { font-size: 0.85rem; }
      .account__shortcuts { gap: 0; }
      .account__item-wrapper + .account__item-wrapper { border-top: 1px solid #ede7df; }
      .account__item {
        display: flex; align-items: center; gap: 12px;
        padding: 12px 14px; border-radius: 12px; color: #17364a; font-size: 0.92rem; font-weight: 500;
        text-decoration: none; transition: background-color 0.15s ease, color 0.15s ease;
      }
      .account__item::before {
        content: ''; display: none; flex-shrink: 0; width: 19px; height: 19px; background: #c44e3a;
        -webkit-mask: var(--wetome-symbol) center / contain no-repeat; mask: var(--wetome-symbol) center / contain no-repeat;
      }
      .account__item::after {
        content: ''; flex-shrink: 0; width: 7px; height: 7px; margin-inline: auto 4px;
        border-top: 1.6px solid currentColor; border-right: 1.6px solid currentColor;
        transform: rotate(45deg); opacity: 0.45;
      }
      .account__item:hover, .account__item:focus-visible { background: #f5f0e9; color: #c44e3a; }
      .account__item:hover::after { opacity: 1; }
      ${symbolregeln}
    `;
    let blatt = null;
    const anhaengen = (konto) => {
      const wurzel = konto.shadowRoot;
      if (!wurzel || !('adoptedStyleSheets' in wurzel)) return false;
      if (!blatt) {
        blatt = new CSSStyleSheet();
        blatt.replaceSync(regeln);
      }
      if (!wurzel.adoptedStyleSheets.includes(blatt)) wurzel.adoptedStyleSheets = [...wurzel.adoptedStyleSheets, blatt];
      return true;
    };
    const alle = () => document.querySelectorAll('shopify-account').forEach(anhaengen);
    if (window.customElements) customElements.whenDefined('shopify-account').then(alle);
    document.addEventListener('shopify:section:load', alle);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wetome-lupe"] && !Shopify.designMode) return;
  try {
    (() => {
    const einrichten = (bereich) => {
      const ansicht = bereich.querySelector('.we-lupe');
      if (!ansicht || ansicht.dataset.bereit) return;
      ansicht.dataset.bereit = 'ja';
      const vorschauen = [...bereich.querySelectorAll('[data-gross-bild]')];
      const bild = ansicht.querySelector('[data-ansicht-bild]');
      const text = ansicht.querySelector('[data-ansicht-text]');
      let aktuell = 0;

      const zurueck = ansicht.querySelector('[data-schritt="-1"]');
      const weiter = ansicht.querySelector('[data-schritt="1"]');

      const zeige = (index) => {
        aktuell = Math.min(Math.max(index, 0), vorschauen.length - 1);
        const vorschau = vorschauen[aktuell];
        bild.src = vorschau.dataset.grossBild;
        bild.alt = vorschau.dataset.beschriftung || '';
        text.textContent = vorschau.dataset.beschriftung || '';
        // Am Anfang gibt es keinen Pfeil zurück, am Ende keinen Pfeil weiter
        if (zurueck) zurueck.hidden = aktuell === 0;
        if (weiter) weiter.hidden = aktuell === vorschauen.length - 1;
      };

      vorschauen.forEach((vorschau, index) =>
        vorschau.addEventListener('click', () => {
          zeige(index);
          ansicht.showModal();
        })
      );
      ansicht.querySelector('[data-zu]').addEventListener('click', () => ansicht.close());
      ansicht.querySelectorAll('[data-schritt]').forEach((knopf) =>
        knopf.addEventListener('click', () => zeige(aktuell + Number(knopf.dataset.schritt)))
      );
      ansicht.addEventListener('click', (ereignis) => {
        if (ereignis.target === ansicht) ansicht.close();
      });
      ansicht.addEventListener('keydown', (ereignis) => {
        if (ereignis.key === 'ArrowRight') zeige(aktuell + 1);
        if (ereignis.key === 'ArrowLeft') zeige(aktuell - 1);
      });
    };
    const alle = (wurzel) => wurzel.querySelectorAll('[data-we-lupe]').forEach(einrichten);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => alle(document));
    } else {
      alle(document);
    }
    document.addEventListener('shopify:section:load', (ereignis) => alle(ereignis.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wetome-rechtstexte"] && !Shopify.designMode) return;
  try {
    (() => {
    const einrichten = () => {
      const rahmen = document.querySelector('.shopify-policy__container');
      if (!rahmen || rahmen.dataset.bereit) return;
      rahmen.dataset.bereit = 'ja';
      rahmen.dataset.richtlinie = location.pathname.split('/').filter(Boolean).pop() || '';

      // Inhaltsverzeichnis ab vier Abschnitten, Sprungmarken aus den Überschriften
      const text = rahmen.querySelector('.shopify-policy__body .rte');
      if (!text) return;
      const ueberschriften = [...text.querySelectorAll('h2')].filter((h) => h.textContent.trim());
      if (ueberschriften.length < 4) return;
      let beschriftung = 'Inhalt';
      try {
        beschriftung = JSON.parse(document.getElementById('we-recht-texte').textContent).inhalt || beschriftung;
      } catch (fehler) {
        // Ohne Übersetzung bleibt die deutsche Beschriftung
      }
      const verzeichnis = document.createElement('nav');
      verzeichnis.className = 'we-recht-inhalt';
      verzeichnis.setAttribute('aria-label', beschriftung);
      const titel = document.createElement('p');
      titel.className = 'we-recht-inhalt__titel';
      titel.textContent = beschriftung;
      const liste = document.createElement('ol');
      ueberschriften.forEach((h, nummer) => {
        if (!h.id) h.id = `abschnitt-${nummer + 1}`;
        const punkt = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${h.id}`;
        link.textContent = h.textContent.trim().replace(/\s+/g, ' ');
        punkt.append(link);
        liste.append(punkt);
      });
      verzeichnis.append(titel, liste);
      text.parentElement.insertBefore(verzeichnis, text);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', einrichten);
    } else {
      einrichten();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
